import { render, staticRenderFns } from "./supplierMain.vue?vue&type=template&id=16d89816&"
import script from "./supplierMain.vue?vue&type=script&lang=js&"
export * from "./supplierMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports